// src/InstrumentPiano.js
import React, { useEffect, useState } from 'react';
import Soundfont from 'soundfont-player';

const PianoKey = ({ note, playNote, stopNote }) => (
  <div
    onMouseDown={() => playNote(note)}
    onMouseUp={() => stopNote(note)}
    className={`key ${note.includes('#') ? 'black' : 'white'}`}
  >
    {note}
  </div>
);

const InstrumentPiano = () => {
  const [audioContext, setAudioContext] = useState(null);
  const [instrument, setInstrument] = useState(null);
  const [currentInstrument, setCurrentInstrument] = useState('acoustic_grand_piano');
  const [activeNotes, setActiveNotes] = useState({});

  const notes = [
    'C4', 'C#4', 'D4', 'D#4', 'E4',
    'F4', 'F#4', 'G4', 'G#4', 'A4', 'A#4', 'B4',
    'C5', 'C#5', 'D5', 'D#5', 'E5',
    'F5', 'F#5', 'G5', 'G#5', 'A5', 'A#5', 'B5'
  ];

  useEffect(() => {
    const ac = new (window.AudioContext || window.webkitAudioContext)();
    setAudioContext(ac);
  }, []);

  useEffect(() => {
    if (audioContext) {
      Soundfont.instrument(audioContext, currentInstrument).then(setInstrument);
    }
  }, [audioContext, currentInstrument]);

  const playNote = (note) => {
    if (instrument) {
      const player = instrument.play(note);
      setActiveNotes((prev) => ({ ...prev, [note]: player }));
    }
  };

  const stopNote = (note) => {
    if (activeNotes[note]) {
      activeNotes[note].stop();
      setActiveNotes((prev) => {
        const updated = { ...prev };
        delete updated[note];
        return updated;
      });
    }
  };

  return (
    <div style={{ padding: '20px' }}>
      <h2>🎹 Virtual Instrument Piano</h2>

      <label>Select Instrument: </label>
      <select onChange={(e) => setCurrentInstrument(e.target.value)} value={currentInstrument}>
        <option value="acoustic_grand_piano">🎹 Piano</option>
        <option value="electric_guitar_clean">🎸 Guitar</option>
        <option value="violin">🎻 Violin</option>
        <option value="saxophone">🎷 Saxophone</option>
        <option value="trumpet">🎺 Trumpet</option>
        <option value="flute">🎼 Flute</option>
        <option value="xylophone">🔔 Xylophone</option>
        <option value="harpsichord">🎶 Harpsichord</option>
      </select>

      <div className="piano">
        {notes.map((note) => (
          <PianoKey key={note} note={note} playNote={playNote} stopNote={stopNote} />
        ))}
      </div>

      <style>{`
        .piano {
          display: flex;
          margin-top: 20px;
        }
        .key {
          border: 1px solid black;
          padding: 20px;
          text-align: center;
          cursor: pointer;
          user-select: none;
        }
        .white {
          background: white;
          width: 40px;
          z-index: 1;
        }
        .black {
          background: black;
          color: white;
          width: 30px;
          margin-left: -15px;
          margin-right: -15px;
          z-index: 2;
          position: relative;
        }
      `}</style>
    </div>
  );
};

export default InstrumentPiano;
